import { MunicipiosApi } from "@/api/municipios.api";
import { Municipios } from "@/models/municipios";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const api = new MunicipiosApi();

const find = (nome: string): AxiosObservable<Municipios> => api.find(nome)

export default {
    find
}